import { render } from "./PedidosHeader.vue?vue&type=template&id=5e2cb232&scoped=true"
import script from "./PedidosHeader.vue?vue&type=script&lang=js"
export * from "./PedidosHeader.vue?vue&type=script&lang=js"

import "./PedidosHeader.vue?vue&type=style&index=0&id=5e2cb232&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2cb232"]])

export default __exports__